// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";

function mapToState(json) {
  return JSON.parse(JSON.stringify(json)).place_id;
}

function getUpdatedPlaceId(mapInst, place_id, onSuccess, onError) {
  var service = new (window.google.maps.places.PlacesService)(mapInst);
  try {
    service.getDetails({
          placeId: place_id,
          fields: ["place_id"]
        }, (function (data) {
            Curry._1(onSuccess, JSON.parse(JSON.stringify(data)).place_id);
          }));
    return ;
  }
  catch (exn){
    return Curry._1(onError, undefined);
  }
}

export {
  mapToState ,
  getUpdatedPlaceId ,
}
/* No side effect */
